module.exports = __webpack_public_path__ + "static/img/productimg5.cdd02ae4.png";